import { Vue, Component } from 'vue-property-decorator';
import TenantCreation from './tenant-creation/tenant-creation';
import TenantList from './tenant-list/tenant-list';

@Component({
    name: 'tenant',
    components: {
        'tenant-list': TenantList,
        'tenant-creation': TenantCreation,
    },
})

export default class Tenant extends Vue {

    private activeComponent: any = 'tenant-list';

    private userData: any = {};

    private tenantList: any = [];
    // ----------------------------------------------------------------------------
    // Actions

    private onSwitchComponent(key: string, userData: any) {
        this.userData = userData;
        this.activeComponent = key;
    }
}
